import { defineStore } from 'pinia';

export const useMaterialsStore = defineStore('materials', {
    state: () => ({ 
        video: {} 
    }),
    getters: {
        currentVideo: (state) => state.video,
    },
    actions: {
    },
})